export default __webpack_public_path__ + "static/media/waiting-list-skip-dark.6efe3fd7.png";